import React from "react";

export default function Header({ onOpenSideMenu }) {
  return (
    <header className="top">
      <button className="icon-btn" onClick={onOpenSideMenu} aria-label="Menü">
        ☰
      </button>
    </header>
  );
}
